interface ProductCardProps {
  id: string;
  name: string;
  image: string;
  price?: string;
  originalPrice?: string;
  discount?: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function ProductCard({ 
  id, 
  name, 
  image, 
  price, 
  originalPrice, 
  discount,
  isHot,
  isNew 
}: ProductCardProps) {
  return (
    <a 
      href={`/product/${id}`}
      className="group block bg-white rounded-xl overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300 transform hover:-translate-y-2 relative"
    >
      {/* Badges */}
      <div className="absolute top-3 left-3 z-10 flex flex-col gap-2">
        {isHot && (
          <span className="px-3 py-1 bg-gradient-to-r from-red-500 to-orange-500 text-white text-xs font-bold rounded-full shadow-lg animate-pulse">
            🔥 熱門
          </span>
        )}
        {isNew && (
          <span className="px-3 py-1 bg-gradient-to-r from-green-500 to-emerald-500 text-white text-xs font-bold rounded-full shadow-lg">
            ✨ 新品
          </span>
        )}
      </div>

      {/* Discount Badge */}
      {discount && (
        <div className="absolute top-3 right-3 z-10">
          <div className="bg-gradient-to-br from-[#1a1f5e] to-[#2563eb] text-white px-3 py-1 rounded-lg font-bold text-sm shadow-lg">
            {discount}
          </div>
        </div>
      )}

      {/* Image Container */}
      <div className="relative w-full h-48 overflow-hidden bg-gradient-to-br from-gray-100 to-gray-200">
        <img 
          src={image} 
          alt={name}
          className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
        />
        {/* Hover Glow Effect */}
        <div className="absolute inset-0 bg-gradient-to-t from-[#2563eb]/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
      </div>

      {/* Content */}
      <div className="p-4">
        <h3 className="text-base font-bold text-gray-800 mb-3 line-clamp-2 group-hover:text-[#2563eb] transition-colors">
          {name}
        </h3>

        {/* Price Section */}
        {price && (
          <div className="flex items-center justify-between">
            <div className="flex flex-col">
              <span className="text-xl font-bold text-[#2563eb]">
                {price}
              </span>
              {originalPrice && (
                <span className="text-sm text-gray-400 line-through">
                  {originalPrice}
                </span>
              )}
            </div>
            <button className="w-9 h-9 bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg whitespace-nowrap">
              <i className="ri-shopping-cart-line text-lg"></i>
            </button>
          </div>
        )}

        {/* No Price - Just View Button */}
        {!price && (
          <div className="flex items-center justify-between">
            <span className="text-sm text-gray-500">查看詳情</span>
            <div className="w-9 h-9 bg-gradient-to-r from-[#1a1f5e] to-[#2563eb] text-white rounded-full flex items-center justify-center group-hover:scale-110 transition-transform shadow-lg">
              <i className="ri-arrow-right-line text-lg"></i>
            </div>
          </div>
        )}
      </div>

      {/* Bottom Glow Effect */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-[#1a1f5e] via-[#2563eb] to-[#1a1f5e] transform scale-x-0 group-hover:scale-x-100 transition-transform duration-300"></div>
    </a>
  );
}
